import { defineComponent as _defineComponent } from 'vue';
import { computed } from 'vue';
import { useFrameStore } from '../seg-frame-store';
import { ASSEMBLY_STEP_TYPES } from '../helpers/frameConstants';
import { computeData, buildSteps } from '../helpers/frameLogic';
import PrintFrameSvg from './PrintFrameSvg.vue';
import HardwareLegend from "../HardwareLegend.vue";
export default /*@__PURE__*/ _defineComponent({
    __name: 'PrintGuidePage',
    props: {
        frame: { type: null, required: true },
        index: { type: Number, required: true },
        total: { type: Number, required: true }
    },
    setup(__props, { expose: __expose }) {
        __expose();
        const props = __props;
        const store = useFrameStore();
        const techData = computed(() => computeData({
            dims: props.frame.dims,
            rawCosts: store.rawCosts,
            tierPrices: store.tierPrices,
            pricingTier: props.frame.pricingTier,
        }));
        const steps = computed(() => techData.value ? buildSteps(techData.value) : []);
        const __returned__ = { props, store, techData, steps, get ASSEMBLY_STEP_TYPES() { return ASSEMBLY_STEP_TYPES; }, PrintFrameSvg, HardwareLegend };
        Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true });
        return __returned__;
    }
});
